import React from 'react';

// add the routes components as you need them
// you will also need to add the new component loaded as route to the routes array

const Home = React.lazy(() => import('./views/Home'));
const About = React.lazy(() => import('./views/About'));
const Solutions = React.lazy(() => import('./views/Solutions'));
const Resources = React.lazy(() => import('./views/Resources'));
const TechSpecs = React.lazy(() => import('./views/TechSpecs'));
const Contact = React.lazy(() => import('./views/Contact'));
const Search = React.lazy(() => import('./views/Search'));
const DemoRequest = React.lazy(() => import('./views/Demo'));
const ConsumerPortal = React.lazy(() => import('./views/ConsumerPortal'));

// sub routes

/* Solutions */
const PortalSolution = React.lazy(() => import('./views/PortalSolution'));
const WebSolution = React.lazy(() => import('./views/WebSolution'));
const PhoneSolution = React.lazy(() => import('./views/PhoneSolution'));

/* Legal */
const PrivacyPolicy = React.lazy(() => import('./views/PrivacyPolicy'));
const SiteTerms = React.lazy(() => import('./views/SiteTerms'));
const CustomerAgreement = React.lazy(() => import('./views/CustomerAgreement'));
const Legal = React.lazy(() => import('./views/Legal'));

const routes = [
    { path: '/', exact: true, name: 'Home' },
    { path: '/home', name: 'Home Dash', component: Home },
    { path: '/about', name: 'About', component: About },
    { path: '/solutions', name: 'Solutions', component: Solutions },
    { path: '/resources', name: 'Resources', component: Resources },
    { path: '/technical-specifications', name: 'Technical Specifications', component: TechSpecs },
    { path: '/contact', name: 'Contact', component: Contact },
    { path: '/search', name: 'Search', component: Search },
    { path: '/demo', name: 'Request Demo', component: DemoRequest },
    { path: '/portal', name: 'Consumer Portal Beta', component: ConsumerPortal },
    { path: '/automated-consumer-portal', name: 'Automated Consumer Portal', component: PortalSolution },
    { path: '/self-pay-websites', name: 'Self Pay Web', component: WebSolution },
    { path: '/automated-phone-systems', name: 'Automated Phone', component: PhoneSolution },
    { path: '/privacy-policy', name: 'Privacy Policy', component: PrivacyPolicy },
    { path: '/customer-agreement', name: 'Customer Agreement', component: CustomerAgreement },
    { path: '/site-terms', name: 'Site Terms', component: SiteTerms },
    { path: '/legal', name: 'Legal', component: Legal }
];

export default routes;
